import { AppUser } from '../types';
import appUserStorage from './app-user-storage';
import AccountType from '../account/AccountType';

export default {
  isAuthenticated(): boolean {
    return (appUserStorage.read() !== null);
  },
  getUserId(): string|null {
    const appUser = appUserStorage.read();
    return (appUser) ? appUser.id : null;
  },
  getUserFirstName(): string|null {
    const appUser = appUserStorage.read();
    return (appUser) ? appUser.firstName : null;
  },
  getUserLastName(): string|null {
    const appUser = appUserStorage.read();
    return (appUser) ? appUser.lastName : null;
  },
  getAccountId(): string|null {
    const appUser = appUserStorage.read();
    return (appUser) ? appUser.account.id : null;
  },
  getAccountType(): number|null {
    const appUser = appUserStorage.read();
    return (appUser) ? appUser.account.type : null;
  },
  isAccountType(accountType: number): boolean {
    return (this.getAccountType() === accountType);
  },
  isServiceProvider(): boolean {
    return this.isAccountType(AccountType.SERVICE_PROVIDER);
  },
  isAgency(): boolean {
    return this.isAccountType(AccountType.AGENCY);
  },
  isClient(): boolean {
    return this.isAccountType(AccountType.CLIENT);
  },
  isCompany(): boolean {
    return this.isAccountType(AccountType.COMPANY);
  },
  getAccountName(): string|null {
    const appUser = appUserStorage.read();
    return (appUser) ? appUser.account.name : null;
  },
  hasScope(scope: string, serviceName: string): boolean {
    const appUser = appUserStorage.read();
    if (!appUser) return false;
    const scopes = appUser.scopes[serviceName] || [];
    return scopes.includes(scope);
  },
  getServices(): string[] {
    const appUser = appUserStorage.read();
    return (appUser) ? Object.keys(appUser.scopes) : [];
  },
  hasService(name: string): boolean {
    return this.getServices().includes(name);
  },
  getAppUser(): AppUser|null {
    return appUserStorage.read();
  },
};
